import React from "react";
import { BRAND_NAME, POWERED_BY_NAME, POWERED_BY_URL } from "../brand.js";

/** "© 2026 Company. Powered by X." — the credit is omitted when not configured. */
export default function BrandFooter({ className = "app-footer" }) {
  return (
    <footer className={className}>
      © {new Date().getFullYear()} {BRAND_NAME}.
      {POWERED_BY_NAME && (
        <>
          {" "}Powered by{" "}
          {POWERED_BY_URL ? (
            <a href={POWERED_BY_URL} target="_blank" rel="noopener noreferrer">
              {POWERED_BY_NAME}
            </a>
          ) : (
            POWERED_BY_NAME
          )}
          .
        </>
      )}
    </footer>
  );
}
